export default __webpack_public_path__ + "static/media/solarisBank.9229950e.png";